// Top Menu Bar Navigation Component - DISABLED
class TopMenuBar {
    constructor() {
        // Menu bar disabled - no initialization
        return;
        this.activeMenu = null;
        this.menus = [
            { 
                id: 'file', 
                label: 'File', 
                items: [
                    { id: 'new-session', label: 'New Session', shortcut: 'Ctrl+N' },
                    { id: 'export-data', label: 'Export Data', shortcut: 'Ctrl+E' },
                    { id: 'import-config', label: 'Import Config' },
                    { id: 'separator' },
                    { id: 'exit', label: 'Exit', shortcut: 'Alt+F4' }
                ]
            },
            { 
                id: 'view', 
                label: 'View',
                items: [
                    { id: 'refresh', label: 'Refresh', shortcut: 'F5' },
                    { id: 'fullscreen', label: 'Toggle Fullscreen', shortcut: 'F11' },
                    { id: 'separator' },
                    { id: 'zoom-in', label: 'Zoom In', shortcut: 'Ctrl+Plus' },
                    { id: 'zoom-out', label: 'Zoom Out', shortcut: 'Ctrl+Minus' },
                    { id: 'zoom-reset', label: 'Reset Zoom', shortcut: 'Ctrl+0' }
                ]
            },
            { 
                id: 'tools', 
                label: 'Tools',
                items: [
                    { id: 'calculator', label: 'Calculator' },
                    { id: 'performance', label: 'Performance Monitor' },
                    { id: 'logs', label: 'View Logs' },
                    { id: 'separator' },
                    { id: 'preferences', label: 'Preferences', shortcut: 'Ctrl+,' }
                ]
            },
            { 
                id: 'bots', 
                label: 'Bots',
                items: [
                    { id: 'start-all', label: 'Start All Bots' },
                    { id: 'stop-all', label: 'Stop All Bots' },
                    { id: 'separator' },
                    { id: 'bot-config', label: 'Bot Configuration' },
                    { id: 'bot-logs', label: 'Bot Logs' }
                ]
            },
            { 
                id: 'help', 
                label: 'Help',
                items: [
                    { id: 'documentation', label: 'Documentation' },
                    { id: 'shortcuts', label: 'Keyboard Shortcuts' },
                    { id: 'separator' },
                    { id: 'about', label: 'About EV+' }
                ]
            }
        ];
        this.onMenuAction = null;
        this.init();
    }

    /**
     * Initialize the top menu bar - DISABLED
     */
    init() {
        // Menu bar disabled - no rendering
        return;
    }

    /**
     * Render the menu bar HTML
     */
    render() {
        const menubar = document.getElementById('top-menubar');
        if (!menubar) {
            console.error('Top menubar container not found');
            return;
        }

        const menusHTML = this.menus.map(menu => `
            <div class="menu-item" data-menu="${menu.id}">
                <span class="menu-label">${menu.label}</span>
                <div class="menu-dropdown" data-dropdown="${menu.id}">
                    ${this.renderMenuItems(menu.items)}
                </div>
            </div>
        `).join('');

        menubar.innerHTML = `
            <div class="menubar-content">
                ${menusHTML}
            </div>
            <div class="menubar-actions">
                <div class="window-controls">
                    <button class="window-btn minimize" id="window-minimize">−</button>
                    <button class="window-btn maximize" id="window-maximize">□</button>
                    <button class="window-btn close" id="window-close">×</button>
                </div>
            </div>
        `;
    }

    /**
     * Render menu dropdown items
     * @param {Array} items - Menu items
     * @returns {string} - HTML string
     */
    renderMenuItems(items) {
        return items.map(item => {
            if (item.id === 'separator') {
                return '<div class="menu-separator"></div>';
            }
            
            return `
                <div class="menu-dropdown-item" data-action="${item.id}">
                    <span class="item-label">${item.label}</span>
                    ${item.shortcut ? `<span class="item-shortcut">${item.shortcut}</span>` : ''}
                </div>
            `;
        }).join('');
    }

    /**
     * Setup event listeners
     */
    setupEventListeners() {
        const menubar = document.getElementById('top-menubar');
        if (!menubar) return;

        // Menu hover/click handlers
        menubar.addEventListener('click', (e) => {
            const menuItem = e.target.closest('.menu-item');
            const dropdownItem = e.target.closest('.menu-dropdown-item');
            
            if (dropdownItem) {
                const action = dropdownItem.dataset.action;
                this.handleMenuAction(action);
                this.closeAllMenus();
            } else if (menuItem) {
                const menuId = menuItem.dataset.menu;
                this.toggleMenu(menuId);
            }
        });

        // Close menus when clicking outside
        document.addEventListener('click', (e) => {
            if (!e.target.closest('#top-menubar')) {
                this.closeAllMenus();
            }
        });

        // Window controls
        const minimizeBtn = document.getElementById('window-minimize');
        const maximizeBtn = document.getElementById('window-maximize');
        const closeBtn = document.getElementById('window-close');

        if (minimizeBtn) minimizeBtn.addEventListener('click', () => this.handleWindowAction('minimize'));
        if (maximizeBtn) maximizeBtn.addEventListener('click', () => this.handleWindowAction('maximize'));
        if (closeBtn) closeBtn.addEventListener('click', () => this.handleWindowAction('close'));
    }

    /**
     * Toggle menu dropdown
     * @param {string} menuId - Menu identifier
     */
    toggleMenu(menuId) {
        this.closeAllMenus();
        
        const menuItem = document.querySelector(`[data-menu="${menuId}"]`);
        const dropdown = document.querySelector(`[data-dropdown="${menuId}"]`);
        
        if (menuItem && dropdown) {
            menuItem.classList.add('active');
            dropdown.classList.add('show');
            this.activeMenu = menuId;
        }
    }

    /**
     * Close all menu dropdowns
     */
    closeAllMenus() {
        document.querySelectorAll('.menu-item').forEach(item => {
            item.classList.remove('active');
        });
        document.querySelectorAll('.menu-dropdown').forEach(dropdown => {
            dropdown.classList.remove('show');
        });
        this.activeMenu = null;
    }

    /**
     * Handle menu action
     * @param {string} action - Action identifier
     */
    handleMenuAction(action) {
        if (this.onMenuAction) {
            this.onMenuAction(action);
        }
    }

    /**
     * Handle window control actions
     * @param {string} action - Window action
     */
    handleWindowAction(action) {
        if (window.electronAPI && window.electronAPI.window) {
            window.electronAPI.window[action]();
        }
    }

    /**
     * Set menu action callback
     * @param {Function} callback - Callback function
     */
    onMenuActionTriggered(callback) {
        this.onMenuAction = callback;
    }
}

// Export singleton instance
window.TopMenuBar = new TopMenuBar();
export { TopMenuBar };
